import { useEffect } from 'react';
import { option } from 'fp-ts';
import { BasicSelect } from 'ui/selects';
import { Tooltip } from 'ui/tooltip';
import { Search } from 'ui/icons';
import { InputText } from 'ui/inputs';
import { useCatalogContext } from 'modules/catalog/catalogSelector/catalogContext';
import { useCatalogFieldSelection } from './hooks/useCatalogFieldSelection';
import { useTranslation } from '../../hooks';

export const DATA_TEST = {
  container: 'catalog-field-selector',
};

export const FieldSelector = () => {
  const { t } = useTranslation();
  const {
    options,
    isLoading,
    onSelect,
    defaultValues,
    isCatalogNone,
    hasInvalidFieldOptions,
    isFieldSelectorDisabled,
    hasCatalogFieldTypeError,
  } = useCatalogFieldSelection();
  const { catalogFieldDetails, hasCatalogFieldError, updateCatalogFieldError } =
    useCatalogContext();

  const tooltipContent = isCatalogNone
    ? t('catalogQuery.missingCatalog')
    : t('catalogQuery.fieldSelectTooltip');

  const selectPlaceholder = hasInvalidFieldOptions
    ? t('catalogQuery.fieldSelectEmpty')
    : t('catalogQuery.fieldSelector');

  useEffect(() => {
    if (option.isSome(catalogFieldDetails)) updateCatalogFieldError();
  }, [catalogFieldDetails]);

  return (
    <Tooltip tooltipContent={tooltipContent} isEnabled={isFieldSelectorDisabled}>
      <BasicSelect
        data-test={DATA_TEST.container}
        options={options}
        placeholder={selectPlaceholder}
        isLoading={isLoading}
        onSelect={onSelect}
        isDisabled={isFieldSelectorDisabled}
        defaultValues={defaultValues}
        isError={hasCatalogFieldTypeError || hasCatalogFieldError}
        isFullWidth
      >
        <InputText
          type="search"
          autoComplete="off"
          id="catalog-input-search"
          Prefix={<Search />}
          placeholder={t('catalogQuery.fieldInputPlaceholder')}
          value=""
          autoFocus
        />
      </BasicSelect>
    </Tooltip>
  );
};
